var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nowrap-container"},[_c('progress-view',{attrs:{"dataOrigin":_vm.dataOrigin,"dataSale":_vm.dataSale}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }